export default "__VITE_ASSET__CUfETGb5__"